<template>
	<v-container
		fluid
	>
		<v-row>
			<slot name="extra-selects" />
			<v-col>
				<purpose-select
					v-model="purpose"
					variant="outlined"
					:label="$gettext('Communication Purpose')"
					@change="$nextTick(() => {$refs.templateTypeTable.index()})"
				/>
			</v-col>
			<v-col>
				<v-text-field
					v-model="templateSearch"
					variant="outlined"
					:label="$gettext('Search Email Template')"
					append-icon="$search"
					hide-details
				/>
			</v-col>
		</v-row>
		<v-row>
			<v-col>
				<model-table
					v-bind="$attrs"
					ref="templateTypeTable"
					v-model="selected"
					:headers="headers"
					:endpoint="tableEndpoint"
					:search="templateSearch"
					show-select
					select-strategy="single"
					item-value="id"
					@input="handleInput"
				/>
			</v-col>
		</v-row>
	</v-container>
</template>
<script>
import ModelTable from './ModelTable.vue';
import PurposeSelect from './PurposeSelect.vue';
export default {
	name: 'EmailTemplateSelect',
	components: {
		PurposeSelect,
		ModelTable
	},

	props: {
		variables: {
			type: String,
			required: false,
			default: null
		}
	},

	emits: ['input',],

	data ()	{
		return {
			selected: [],
			purpose: null,
			purposes: [],
			purposeLoading: true,
			language: 'NL',
			languages: [],
			templateSearch: null,
			headers: [
				{
					title: this.$gettext('Template Code'),
					value: 'name',
				},
				{
					title: this.$gettext('Title'),
					value: 'title',
				},
				{
					title: this.$gettext('Purpose'),
					value: 'purpose',
				},
			],
			searchResult: [],
		};
	},

	computed: {
		templateType () {
			return (this.selected.length > 0) ? this.selected[0] : '';
		},

		tableEndpoint () {
			return `/bo/emailtemplatetypes/index?method=2
			${this.purpose ? `&purpose=${this.purpose}` : ''}
			${this.variables ? `&variables=${this.variables}` : '' }`;
		}
	},

	methods: {
		/**
		 *
		 */
		handleInput () {
			this.$emit('input', this.templateType);
		}
	}
};
</script>
